export const palette = {
  gray: {
    50: '#F9F8F8',
    100: '#EBE6E2',
    200: '#D7CEC5',
    300: '#BEB3A7',
    400: '#A49788',
    500: '#887A69',
    600: '#6B5E4F',
    700: '#514639',
    800: '#3C3228',
    900: '#2A231B',
    '000': 'rgba(63, 43, 24, 0.0000)',
    '002': 'rgba(63, 43, 24, 0.0200)',
    '004': 'rgba(63, 43, 24, 0.0400)',
    '008': 'rgba(63, 43, 24, 0.0800)',
    '016': 'rgba(63, 43, 24, 0.1600)',
    '024': 'rgba(63, 43, 24, 0.2400)',
    '036': 'rgba(63, 43, 24, 0.3600)',
    '050': 'rgba(63, 43, 24, 0.5000)',
    '064': 'rgba(63, 43, 24, 0.6400)',
    '076': 'rgba(63, 43, 24, 0.7600)',
    '084': 'rgba(63, 43, 24, 0.8400)',
    '092': 'rgba(63, 43, 24, 0.9200)',
    '096': 'rgba(63, 43, 24, 0.9600)',
  },
  amber: {
    50: '#FFFAEE',
    100: '#FFF2D8',
    200: '#FFE5B4',
    300: '#FDCD7E',
    400: '#FAAD45',
    500: '#F09226',
    600: '#DA7918',
    700: '#BA5D11',
    800: '#8B3F0C',
    900: '#552407',
    '008': 'rgba(186, 96, 17, 0.0800)',
    '064': 'rgba(186, 96, 17, 0.6400)',
  },
  blue: {
    50: '#F2F9FE',
    100: '#DCECF8',
    200: '#BCD9EF',
    300: '#95C1E2',
    400: '#74AAD3',
    500: '#5591BF',
    600: '#3977A7',
    700: '#235E8B',
    800: '#11446B',
    900: '#062740',
    '008': 'rgba(35, 94, 139, 0.0800)',
    '064': 'rgba(35, 94, 139, 0.6400)',
  },
  red: {
    50: '#FFF2F2',
    100: '#FFE1E1',
    200: '#FFC8C8',
    300: '#FAA2A0',
    400: '#F37977',
    500: '#E64E4B',
    600: '#D52E2B',
    700: '#B81815',
    800: '#930A08',
    900: '#650503',
    '008': 'rgba(184, 24, 21, 0.0800)',
    '064': 'rgba(184, 24, 21, 0.6400)',
  },
  green: {
    50: '#F4FDF2',
    100: '#DFF7DA',
    200: '#CBEDC5',
    300: '#B1E0A8',
    400: '#93CC88',
    500: '#73B367',
    600: '#559549',
    700: '#3D7732',
    800: '#27551E',
    900: '#14320F',
    '008': 'rgba(61, 119, 50, 0.0800)',
    '064': 'rgba(61, 119, 50, 0.6400)',
  },
  white: {
    white: '#FFFFFF',
    '000': 'rgba(255, 255, 255, 0.0000)',
    '002': 'rgba(255, 255, 255, 0.0200)',
    '004': 'rgba(255, 255, 255, 0.0400)',
    '008': 'rgba(255, 255, 255, 0.0800)',
    '016': 'rgba(255, 255, 255, 0.1600)',
    '024': 'rgba(255, 255, 255, 0.2400)',
    '036': 'rgba(255, 255, 255, 0.3600)',
    '050': 'rgba(255, 255, 255, 0.5000)',
    '064': 'rgba(255, 255, 255, 0.6400)',
    '076': 'rgba(255, 255, 255, 0.7600)',
    '084': 'rgba(255, 255, 255, 0.8400)',
    '092': 'rgba(255, 255, 255, 0.9200)',
    '096': 'rgba(255, 255, 255, 0.9600)',
  },
}
